module.exports = __webpack_public_path__ + "media/37.2fdbefa3.mp3";